<template>
  <h2 v-if="attendee" class="text-center">WELCOME TO YOUR ITINERARY, {{ attendee.name | uppercase }}</h2>
</template>

<script>
export default {
  name: 'Welcome',
  props: ['attendee']
}
</script>
